import { ModelGovernanceSchema, type GovernedFact } from './schemas/ai-governance';
import { GOOGLE_STANDARD_PRICES, GOOGLE_PRICE_EVIDENCE } from './google-pricing';

const evidence = 'https://ai.google.dev/gemini-api/docs/embeddings?hl=en';
const verifiedAt = '2026-10-17T02:47:32Z';
function providerFact(value: number, unit: GovernedFact['unit']): GovernedFact {
  return { value, unit, scope: 'provider_request', source: 'verified_documentation',
    evidence, verifiedAt, status: 'known', revision: 1 };
}
function priceFact(modality: 'TEXT' | 'IMAGE' | 'AUDIO' | 'VIDEO'): GovernedFact {
  const value = GOOGLE_STANDARD_PRICES['gemini-embedding-2']?.input[modality] ?? null;
  return { value, unit: 'USD_per_million_tokens', scope: 'provider_request',
    source: 'verified_documentation', evidence: GOOGLE_PRICE_EVIDENCE.evidenceUrl,
    verifiedAt: GOOGLE_PRICE_EVIDENCE.verifiedAt, status: value === null ? 'unknown' : 'known', revision: 1 };
}
export const GEMINI_EMBEDDING_DEFINITION_REVISION = 'google-embedding-contract-2026-10-17-v1';
/** Provider limits are NOT local ingestion policy. PDF jobs rasterize pages. */
export const GEMINI_EMBEDDING_GOVERNANCE = ModelGovernanceSchema.parse({
  schemaVersion: 1,
  inputTokens: providerFact(8192, 'tokens'),
  imagesPerRequest: providerFact(6, 'images'),
  nativePdfPagesPerRequest: providerFact(6, 'pages'),
  audioSecondsPerRequest: providerFact(180, 'seconds'),
  videoSecondsPerRequest: providerFact(120, 'seconds'),
  nativeDimensions: providerFact(3072, 'dimensions'),
  minimumOutputDimensions: providerFact(128, 'dimensions'),
  maximumOutputDimensions: providerFact(3072, 'dimensions'),
  inputModalities: {
    value: ['text', 'image', 'audio', 'video', 'pdf'], unit: 'identifier',
    scope: 'provider_request', source: 'verified_documentation',
    evidence, verifiedAt, status: 'known', revision: 1,
  },
  textPrice: priceFact('TEXT'),
  imagePrice: priceFact('IMAGE'),
  audioPrice: priceFact('AUDIO'),
  videoPrice: priceFact('VIDEO'),
  storedDimensions: {
    value: 3072, unit: 'dimensions', scope: 'storage', source: 'application_policy',
    evidence: 'packages/backend/src/services/ai/embedder-resolver.service.ts',
    verifiedAt, status: 'known', revision: 1,
  },
  applicationVideoSeconds: {
    value: 81, unit: 'seconds', scope: 'application_request', source: 'application_policy',
    evidence: 'packages/backend/src/services/ai/gemini-embeddings.service.ts',
    verifiedAt, status: 'known', revision: 1,
  },
  applicationPdfPages: {
    value: 100, unit: 'pages', scope: 'application_job', source: 'application_policy',
    evidence: 'PDF rasterized page-by-page; not native PDF requests',
    verifiedAt, status: 'known', revision: 1,
  },
});
